import moment from 'moment';

interface JwtPayload {
  exp?: number;
}

const decodeJwtPayload = (token: string): JwtPayload | undefined => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return undefined;

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '==='.slice((base64.length + 3) % 4);

    return JSON.parse(decodeURIComponent(escape(window.atob(padded))));
  } catch (e) {
    return undefined;
  }
};

// 取出JWT內的到期時間(exp)並轉為顯示用字串，無法解析時回傳空字串
export const getJwtExpiredTime = (token?: string, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!token) return '';

  const exp = decodeJwtPayload(token)?.exp;

  return exp ? moment.unix(exp).format(format) : '';
};
